import babyloanForm from './babyloan-form/babyloan-form.vue';
import babyloanApi from '../../api/babyloan-api';
import queryString from 'query-string';
import { ERROR_FIELDS, COOKIE_PORTAL_ID_NAME } from '../../common/js/constants/constants';
import eventBus from '../../common/js/event-bus/event-bus';

export default {
	data: () => ({
		model: {
			captchaKey: null,
			sourceName: null,
			sourceMedium: null,
			sourceCampaign: null,
			registrationUrl: window.location.href,
			portalId: null,
			koFilter: null
		},
		captcha: {
			htmlFragment: null,
			valid: null
		},
		captchaKey: null,
		captchaError: false,
		captchaImg: null,
		success: false,
		technicalError: false
	}),
	props: {
		version: Number
	},
	components: {
		babyloanForm
	},
	methods: {
		async getCaptcha() {
			try {
				const captchaResponse = await babyloanApi.getCaptcha();
				this.model.captchaKey = captchaResponse.data.captchaKey;
				if (captchaResponse.data.captchaKey && captchaResponse.data.captcha && captchaResponse.data.captcha.htmlFragment) {
					this.setCaptchaImg(captchaResponse.data.captcha);
				}
			} catch (e) {
				this.technicalError = true;
			}
		},
		setCaptchaImg(captcha) {
			this.captchaImg = `data:image/png;base64, ${captcha.htmlFragment}`;
		},
		async onSubmitForm(model) {
			try {
				this.captchaError = false;
				this.technicalError = false;
				const sentModel = Object.assign({}, model, this.model);
				await babyloanApi.postBabyloanRegistration(sentModel);
				this.success = true;
				if (this.success) {
					this.$gtm.trackEvent({
						event: 'expectingBabyInterestSuccess'
					});
				}
			} catch (err) {
				if (err.response && err.response.status == 400 && err.response.data && err.response.data.errorField == ERROR_FIELDS.CAPTCHA) {
					this.captchaError = true;
					this.getCaptcha();
				} else {
					this.captchaError = false;
					this.technicalError = true;
					this.$gtm.trackEvent({
						event: 'expectingBabyInterestFail'
					});
				}
			}
		}
	},
	created() {
		eventBus.$on('babyloanKoFinished', (koFilterValue) => {
			this.model.koFilter = koFilterValue;
		});
		let parsed = queryString.parse(location.search);
		this.getCaptcha();

		let portalId = this.$cookie.get(COOKIE_PORTAL_ID_NAME);
		if (portalId) {
			this.model.portalId = portalId;
		}
		this.model.sourceName = parsed.utm_source ? parsed.utm_source.substring(0, 255) : undefined;
		this.model.sourceMedium = parsed.utm_medium ? parsed.utm_medium.substring(0, 255) : undefined;
		this.model.sourceCampaign = parsed.utm_campaign ? parsed.utm_campaign.substring(0, 255) : undefined;
	}
};
